import { render, staticRenderFns } from "./CookiesView.vue?vue&type=template&id=26af2753&scoped=true"
import script from "./CookiesView.vue?vue&type=script&lang=js"
export * from "./CookiesView.vue?vue&type=script&lang=js"
import style0 from "./CookiesView.vue?vue&type=style&index=0&id=26af2753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af2753",
  null
  
)

export default component.exports